export function fadeIn(target) {
  let level = 0;
  const inTimer = setInterval(() => {
    level = fadeInAction(target, level, inTimer);
  }, 50);
}

export function fadeOut(target) {
  let level = 1;
  const outTimer = setInterval(() => {
    level = fadeOutAction(target, level, outTimer);
  }, 50);
}

function fadeInAction(target, level, inTimer) {
  level += 0.1;
  changeOpacity(target, level);
  if (level > 1) {
    clearInterval(inTimer);
    target.style.display = "block";
  }
  return level;
}

function fadeOutAction(target, level, outTimer) {
  level -= 0.1;
  changeOpacity(target, level);
  if (level < 0) {
    clearInterval(outTimer);
    target.style.display = "none";
  }
  return level;
}

function changeOpacity(target, level) {
  target.style.opacity = level;
  target.style.MozOpacity = level;
  target.style.KhtmlOpacity = level;
  const opacity = level * 100;
  target.style.Msfilter = `progid: DXImageTransform.Microsoft.Alpha(Opacity="${opacity}")`;
  target.style.filter = `alpha(opacity="${opacity}");`;
}
